import { map } from 'rxjs/operators/map';
import { LocationSerializer } from '../../models';
import ajax from '../../utils/ajax';

class LocationService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPathGroup = '/networkAsset/airfinder/locations';
  configurationPath = '/networkAsset/airfinder/location';
  geoJsonConfigurationPath = '/networkAsset/airfinder/area'

  /**
    Create a Location
    @param {Object} Location
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (location, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPathGroup}`,
        body: LocationSerializer.serialize(location),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => LocationSerializer.normalize(data.response)));
  };

  /**
    Edit a Location
    @param {Object} Location
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  edit = (location, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${location.id}`,
        body: LocationSerializer.serializeEdit(location),
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        responseType: 'json'
      },
      store
    ).pipe(map(data => LocationSerializer.normalize(data.response)));
  };

  /**
    Delete a Location
    @param {Object} Location
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the response
  */
  delete = (location, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}`,
        body: LocationSerializer.serializeDelete(location),
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };

  /**
    Get Locations that belong to a zone
    @param {String} zoneId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized list of locations
  */
  getByZoneId = (zoneId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?zoneId=${zoneId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.map(LocationSerializer.normalize)));
  };

  /**
    Get Locations that belong to a site
    @param {String} siteId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized list of locations
  */
  getBySiteId = (siteId: string, store: Store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.map(LocationSerializer.normalize)));
  };

  getGeoJsonByAreaId = (areaId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.geoJsonConfigurationPath}/${areaId}/geojson`,
        method: 'GET',
        responseType: 'json'
      },
      store
    );
  };
}

export default new LocationService();



// WEBPACK FOOTER //
// ./src/services/location/index.js